import Graticule from 'ol/layer/Graticule';
import Stroke from 'ol/style/Stroke';

import Map from 'ol/Map';
import View from 'ol/View';
import OSM from 'ol/source/OSM';

import {getCenter} from 'ol/extent.js';

import ImageLayer from 'ol/layer/Image';
import TileLayer from 'ol/layer/Tile';
import {transform, fromLonLat} from 'ol/proj';
import Static from 'ol/source/ImageStatic.js';

import ScaleLine from 'ol/control/ScaleLine';

import Projection from 'ol/proj/Projection';
import {register} from 'ol/proj/proj4.js';
import proj4 from 'proj4';

import {ZoomToExtent} from 'ol/control';
import * as dayjs from 'dayjs';

const day0 = dayjs();
const day1 = day0.add(1,'day');
const day2 = day0.add(2,'day');
const day3 = day0.add(3,'day');
const day4 = day0.add(4,'day');
const day5 = day0.add(5,'day');
const day6 = day0.add(6,'day');
const day7 = day0.add(7,'day');
const day8 = day0.add(8,'day');
const day9 = day0.add(9,'day');
const day10 = day0.add(10,'day');
const day11 = day0.add(11,'day');

const YMD = day0.format('YYYYMMDD');
const YMD1 = day1.format('YYYYMMDD');
const YMD2 = day2.format('YYYYMMDD');
const YMD3 = day3.format('YYYYMMDD');
const YMD4 = day4.format('YYYYMMDD');
const YMD5 = day5.format('YYYYMMDD');
const YMD6 = day6.format('YYYYMMDD');
const YMD7 = day7.format('YYYYMMDD');
const YMD8 = day8.format('YYYYMMDD');
const YMD9 = day9.format('YYYYMMDD');
const YMD10 = day10.format('YYYYMMDD');
const YMD11 = day11.format('YYYYMMDD');

//document.getElementById("date-input0").value = YMD;
//document.getElementById("date-input1").value = YMD1;
//document.getElementById("date-input2").value = YMD2;
//document.getElementById("date-input3").value = YMD3;
//document.getElementById("date-input4").value = YMD4;
//document.getElementById("date-input5").value = YMD5;
//document.getElementById("date-input6").value = YMD6;
//document.getElementById("date-input7").value = YMD7;
//document.getElementById("date-input8").value = YMD8;
//document.getElementById("date-input9").value = YMD9;
//document.getElementById("date-input10").value = YMD10;

const outputElement11 = document.getElementById("output-area11");

// 3. Update the element's text content with the constant's value
if (outputElement11) {
    // Use .textContent for security (prevents XSS attacks when inserting plain text)
    // or .innerHTML if you are inserting actual HTML markup from a trusted source
    outputElement11.textContent = YMD11;
}


const base_path = 'cached-images'; // local cached images base path
const lustre_base_path = 'fwi-images'; // remote lustre images base path

var path0  = base_path+'/FWI_forecast_'+YMD+'_day+0.png'
var path1  = base_path+'/FWI_forecast_'+YMD+'_day+1.png'
var path2  = base_path+'/FWI_forecast_'+YMD+'_day+2.png'
var path3  = base_path+'/FWI_forecast_'+YMD+'_day+3.png'
var path4  = base_path+'/FWI_forecast_'+YMD+'_day+4.png'
var path5  = base_path+'/FWI_forecast_'+YMD+'_day+5.png'
var path6  = base_path+'/FWI_forecast_'+YMD+'_day+6.png'
var path7  = base_path+'/FWI_forecast_'+YMD+'_day+7.png'
var path8  = base_path+'/FWI_forecast_'+YMD+'_day+8.png'
var path9  = base_path+'/FWI_forecast_'+YMD+'_day+9.png'
var path10 = base_path+'/FWI_forecast_'+YMD+'_day+10.png'
var path11 = base_path+'/FWI_forecast_'+YMD+'_day+11.png'

var tryRequire = (path0) => { // test if image0 is present locally
  try {
   return require(`${path0}`);
  } catch (err) {
   return null;
  }
};

path0 = tryRequire(path0) ? path0 : lustre_base_path+'/Image0/FWI_forecast_'+YMD+'_day+0.png';

tryRequire = (path1) => { // test if image1 is present locally
  try {
   return require(`${path1}`);
  } catch (err) {
   return null;
  }
};

path1 = tryRequire(path1) ? path1 : lustre_base_path+'/Image1/FWI_forecast_'+YMD+'_day+1.png';

tryRequire = (path2) => { // test if image2 is present locally
  try {
   return require(`${path2}`);
  } catch (err) {
   return null;
  }
};

path2 = tryRequire(path2) ? path2 : lustre_base_path+'/Image2/FWI_forecast_'+YMD+'_day+2.png';

tryRequire = (path3) => { // test if image3 is present locally
  try {
   return require(`${path3}`);
  } catch (err) {
   return null;
  }
};

path3 = tryRequire(path3) ? path3 : lustre_base_path+'/Image3/FWI_forecast_'+YMD+'_day+3.png';

tryRequire = (path4) => { // test if image4 is present locally
  try {
   return require(`${path4}`);
  } catch (err) {
   return null;
  }
};

path4 = tryRequire(path4) ? path4 : lustre_base_path+'/Image4/FWI_forecast_'+YMD+'_day+4.png';

tryRequire = (path5) => { // test if image5 is present locally
  try {
   return require(`${path5}`);
  } catch (err) {
   return null;
  }
};

path5 = tryRequire(path5) ? path5 : lustre_base_path+'/Image5/FWI_forecast_'+YMD+'_day+5.png';

tryRequire = (path6) => { // test if image6 is present locally
  try {
   return require(`${path6}`);
  } catch (err) {
   return null;
  }
};

path6 = tryRequire(path6) ? path6 : lustre_base_path+'/Image6/FWI_forecast_'+YMD+'_day+6.png';

tryRequire = (path7) => { // test if image7 is present locally
  try {
   return require(`${path7}`);
  } catch (err) {
   return null;
  }
};

path7 = tryRequire(path7) ? path7 : lustre_base_path+'/Image7/FWI_forecast_'+YMD+'_day+7.png';

tryRequire = (path8) => { // test if image8 is present locally
  try {
   return require(`${path8}`);
  } catch (err) {
   return null;
  }
};

path8 = tryRequire(path8) ? path8 : lustre_base_path+'/Image8/FWI_forecast_'+YMD+'_day+8.png';

tryRequire = (path9) => { // test if image9 is present locally
  try {
   return require(`${path9}`);
  } catch (err) {
   return null;
  }
};

path9 = tryRequire(path9) ? path9 : lustre_base_path+'/Image9/FWI_forecast_'+YMD+'_day+9.png';

tryRequire = (path10) => { // test if image10 is present locally
  try {
   return require(`${path10}`);
  } catch (err) {
   return null;
  }
};

path10 = tryRequire(path10) ? path10 : lustre_base_path+'/Image10/FWI_forecast_'+YMD+'_day+10.png';

tryRequire = (path11) => { // test if image8 is present locally
  try {
   return require(`${path11}`);
  } catch (err) {
   return null;
  }
};

path11 = tryRequire(path11) ? path11 : lustre_base_path+'/Image11/FWI_forecast_'+YMD+'_day+11.png';

var Image0  = path0;  //+'/FWI_forecast_'+YMD+'_day+0.png';
var Image1  = path1;  //'fwi-images/Image1/FWI_forecast_'+YMD+'_day+1.png'; // testing latency of lustre access vs local access
var Image2  = path2;  //+'/FWI_forecast_'+YMD+'_day+2.png';
var Image3  = path3;  //+'/FWI_forecast_'+YMD+'_day+2.png';
var Image4  = path4;  //+'/FWI_forecast_'+YMD+'_day+2.png';
var Image5  = path5;  //+'/FWI_forecast_'+YMD+'_day+2.png';
var Image6  = path6;  //+'/FWI_forecast_'+YMD+'_day+2.png';
var Image7  = path7;  //+'/FWI_forecast_'+YMD+'_day+2.png';
var Image8  = path8;  //+'/FWI_forecast_'+YMD+'_day+2.png';
var Image9  = path9;  //+'/FWI_forecast_'+YMD+'_day+2.png';
var Image10 = path10; //+'/FWI_forecast_'+YMD+'_day+2.png';
var Image11 = path11; //+'/FWI_forecast_'+YMD+'_day+2.png';


// Try: Image.prototype.decode = null;

proj4.defs('lcc', '+proj=lcc +lat_0=63 +lon_0=15 +lat_1=63 +lat_2=63 +R=6.371e+06 +datum=WGS84 +no_defs')
register(proj4)


/*
  Extent is given by [min x, min y, max x, max y]

  In the netCDF file minimum and maximum for the model area is set to
  latitude 51 to 88 and longitude to -20 to 80.

  However the extent of the data-set is much smaller.  The lower left
  hand corner is at 52.30272N 1.918465E and the upper right hand corner
  is at 72.18485N 41.76428E

  The following values have been collected from the NetCDF file
*/

/* some minor adjustment to the extent to get the overlay to fit
 * better with the background map */

//var imageExtent = [-897442.0, -1104322.0, 897558.0 , 1215678.0 + 15000]; //settled on skogbrannfare.met.no

//var imageExtent = [-897442.0, -1104322.0, 897558.0 , 1215678.0 + 25000]; //new approximation for north (work in progress) 
var imageExtent = [-897442.2, -1104322.0, 897557.8 , 1215678.0]; //TEST

/*
1st index:
2nd index: moves bottom up
3rd index: moves right edge to the right
4th index: 
*/

// var imageExtent = [-897442.0 -2000, -1104322.0 - 2000, 897558.0 + 500, 1215678.0 + 500];

//var imageExtent = [-897442.0 -1500, -1104322.0 -1500, 897558.0 -1500, 1215678.0 -1500];
//var imageExtent = [-897442.0 -2000, -1104322.0 -2000, 897558.0 +2000, 1215678.0 +2000]; // last value


/*
  Given that the extent of the image is limited, we can limit the map
  to an area just larger than the area covered by the dataset

  The area selected is
*/

var mapExtent = [-1087158.85, -1329590.95, 986554.94, 1360780.73];

/* center arround 64N 14E */

//var centerExtent = [-269430.90 - 600000, -211954.21 - 100000, -269430.90 + 600000, -211954.21 + 100000];
//var centerExtent = [-48750.19 - 600000, 111579.69 - 100000, -48750.19 + 600000, 111579.69 + 100000];
//var centerExtent = [-48000.19 - 600000, 111579.69 - 100000, -48000.19 + 600000, 111579.69 + 100000];
var centerExtent = [-48750.19 - 600000, 141579.69 - 100000, -48750.19 + 600000, 141579.69 + 100000];

// center_x = (cE0 + cE2)/2 ; center_y = (cE1 + cE3)/2 

var LambertConformalConic = new Projection({
    code: 'lcc',
    global: false,
    extent: mapExtent,
    worldExtent: mapExtent
});

var layer0 = new TileLayer({
    preload: Infinity,
    source: new OSM({
	"url" : "https://{a-c}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png?key=cb1_2fer_1_a901c55f7f116adae7ded39e"
    })
});

var layer1 = new TileLayer({
    preload: Infinity,
    source: new OSM({
	"url" : "https://{a-c}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png?key=cb1_2fer_1_a901c55f7f116adae7ded39e"
    })
});

var layer2 = new TileLayer({
    preload: Infinity,
    source: new OSM({
	"url" : "https://{a-c}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png?key=cb1_2fer_1_a901c55f7f116adae7ded39e"
    })
});

var layer3 = new TileLayer({
    preload: Infinity,
    source: new OSM({
	"url" : "https://{a-c}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png?key=cb1_2fer_1_a901c55f7f116adae7ded39e"
    })
});

var layer4 = new TileLayer({
    preload: Infinity,
    source: new OSM({
	"url" : "https://{a-c}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png?key=cb1_2fer_1_a901c55f7f116adae7ded39e"
    })
});

var layer5 = new TileLayer({
    preload: Infinity,
    source: new OSM({
	"url" : "https://{a-c}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png?key=cb1_2fer_1_a901c55f7f116adae7ded39e"
    })
});

var layer6 = new TileLayer({
    preload: Infinity,
    source: new OSM({
	"url" : "https://{a-c}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png?key=cb1_2fer_1_a901c55f7f116adae7ded39e"
    })
});

var layer7 = new TileLayer({
    preload: Infinity,
    source: new OSM({
	"url" : "https://{a-c}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png?key=cb1_2fer_1_a901c55f7f116adae7ded39e"
    })
});

var layer8 = new TileLayer({
    preload: Infinity,
    source: new OSM({
	"url" : "https://{a-c}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png?key=cb1_2fer_1_a901c55f7f116adae7ded39e"
    })
});

var layer9 = new TileLayer({
    preload: Infinity,
    source: new OSM({
	"url" : "https://{a-c}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png?key=cb1_2fer_1_a901c55f7f116adae7ded39e"
    })
});

var layer10 = new TileLayer({
    preload: Infinity,
    source: new OSM({
	"url" : "https://{a-c}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png?key=cb1_2fer_1_a901c55f7f116adae7ded39e"
    })
});

var layer11 = new TileLayer({
    preload: Infinity,
    source: new OSM({
	"url" : "https://{a-c}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png?key=cb1_2fer_1_a901c55f7f116adae7ded39e"
    })
});

/* rotate view 30 degrees = about 0.5 rad */

var mview = new View({
    projection: LambertConformalConic,
    /*center: fromLonLat([12,63], LambertConformalConic),*/
    center: transform(getCenter(centerExtent), LambertConformalConic, LambertConformalConic),
    zoom: 1,
    maxZoom: 9,
    minZoom: 1,
    //rotation: -0.2,
});

var map0 = new Map({
    target: 'map0',
    layers: [layer0],
    view: mview
});

var map1 = new Map({
    target: 'map1',
    layers: [layer1],
    view: mview
});

var map2 = new Map({
    target: 'map2',
    layers: [layer2],
    view: mview
});

var map3 = new Map({
    target: 'map3',
    layers: [layer3],
    view: mview
});

var map4 = new Map({
    target: 'map4',
    layers: [layer4],
    view: mview
});

var map5 = new Map({
    target: 'map5',
    layers: [layer5],
    view: mview
});

var map6 = new Map({
    target: 'map6',
    layers: [layer6],
    view: mview
});

var map7 = new Map({
    target: 'map7',
    layers: [layer7],
    view: mview
});

var map8 = new Map({
    target: 'map8',
    layers: [layer8],
    view: mview
});

var map9 = new Map({
    target: 'map9',
    layers: [layer9],
    view: mview
});

var map10 = new Map({
    target: 'map10',
    layers: [layer10],
    view: mview
});

var map11 = new Map({
    target: 'map11',
    layers: [layer11],
    view: mview
});


var fwi_image_0 = new ImageLayer({
    opacity: 0.55,
    source: new Static({
        url: Image0,
	    imageExtent: imageExtent,
	    crossOrigin: ''
    })
})

var fwi_image_1 = new ImageLayer({
    opacity: 0.55,
    source: new Static({
        url: Image1,
	    imageExtent: imageExtent,
	    crossOrigin: ''
    })
})

var fwi_image_2 = new ImageLayer({
    opacity: 0.55,
    source: new Static({
        url: Image2,
	    imageExtent: imageExtent,
	    crossOrigin: ''
    })
})

var fwi_image_3 = new ImageLayer({
    opacity: 0.55,
    source: new Static({
        url: Image3,
	    imageExtent: imageExtent,
	    crossOrigin: ''
    })
})

var fwi_image_4 = new ImageLayer({
    opacity: 0.55,
    source: new Static({
        url: Image4,
	    imageExtent: imageExtent,
	    crossOrigin: ''
    })
})

var fwi_image_5 = new ImageLayer({
    opacity: 0.55,
    source: new Static({
        url: Image5,
	    imageExtent: imageExtent,
	    crossOrigin: ''
    })
})

var fwi_image_6 = new ImageLayer({
    opacity: 0.55,
    source: new Static({
        url: Image6,
	    imageExtent: imageExtent,
	    crossOrigin: ''
    })
})

var fwi_image_7 = new ImageLayer({
    opacity: 0.55,
    source: new Static({
        url: Image7,
	    imageExtent: imageExtent,
	    crossOrigin: ''
    })
})

var fwi_image_8 = new ImageLayer({
    opacity: 0.55,
    source: new Static({
        url: Image8,
	    imageExtent: imageExtent,
	    crossOrigin: ''
    })
})

var fwi_image_9 = new ImageLayer({
    opacity: 0.55,
    source: new Static({
        url: Image9,
	    imageExtent: imageExtent,
	    crossOrigin: ''
    })
})

var fwi_image_10 = new ImageLayer({
    opacity: 0.55,
    source: new Static({
        url: Image10,
	    imageExtent: imageExtent,
	    crossOrigin: ''
    })
})

var fwi_image_11 = new ImageLayer({
    opacity: 0.55,
    source: new Static({
        url: Image11,
	    imageExtent: imageExtent,
	    crossOrigin: ''
    })
})

map0.addLayer(fwi_image_0);
map1.addLayer(fwi_image_1);
map2.addLayer(fwi_image_2);
map3.addLayer(fwi_image_3);
map4.addLayer(fwi_image_4);
map5.addLayer(fwi_image_5);
map6.addLayer(fwi_image_6);
map7.addLayer(fwi_image_7);
map8.addLayer(fwi_image_8);
map9.addLayer(fwi_image_9);
map10.addLayer(fwi_image_10);
map11.addLayer(fwi_image_11);

map0.addControl(new ScaleLine());
map1.addControl(new ScaleLine());
map2.addControl(new ScaleLine());
map3.addControl(new ScaleLine());
map4.addControl(new ScaleLine());
map5.addControl(new ScaleLine());
map6.addControl(new ScaleLine());
map7.addControl(new ScaleLine());
map8.addControl(new ScaleLine());
map9.addControl(new ScaleLine());
map10.addControl(new ScaleLine());
map11.addControl(new ScaleLine());

var home_zoom0 = new ZoomToExtent({
    extent: centerExtent,
    label: 'Z',
    tipLabel: "'Zero zoom' - zoom to full map"
});

var home_zoom1 = new ZoomToExtent({
    extent: centerExtent,
    label: 'Z',
    tipLabel: "'Zero zoom' - zoom to full map"
});

var home_zoom2 = new ZoomToExtent({
    extent: centerExtent,
    label: 'Z',
    tipLabel: "'Zero zoom' - zoom to full map"
});

var home_zoom3 = new ZoomToExtent({
    extent: centerExtent,
    label: 'Z',
    tipLabel: "'Zero zoom' - zoom to full map"
});

var home_zoom4 = new ZoomToExtent({
    extent: centerExtent,
    label: 'Z',
    tipLabel: "'Zero zoom' - zoom to full map"
});

var home_zoom5 = new ZoomToExtent({
    extent: centerExtent,
    label: 'Z',
    tipLabel: "'Zero zoom' - zoom to full map"
});

var home_zoom6 = new ZoomToExtent({
    extent: centerExtent,
    label: 'Z',
    tipLabel: "'Zero zoom' - zoom to full map"
});

var home_zoom7 = new ZoomToExtent({
    extent: centerExtent,
    label: 'Z',
    tipLabel: "'Zero zoom' - zoom to full map"
});

var home_zoom8 = new ZoomToExtent({
    extent: centerExtent,
    label: 'Z',
    tipLabel: "'Zero zoom' - zoom to full map"
});

var home_zoom9 = new ZoomToExtent({
    extent: centerExtent,
    label: 'Z',
    tipLabel: "'Zero zoom' - zoom to full map"
});

var home_zoom10 = new ZoomToExtent({
    extent: centerExtent,
    label: 'Z',
    tipLabel: "'Zero zoom' - zoom to full map"
});

var home_zoom11 = new ZoomToExtent({
    extent: centerExtent,
    label: 'Z',
    tipLabel: "'Zero zoom' - zoom to full map"
});

map0.addControl(home_zoom0);
map1.addControl(home_zoom1);
map2.addControl(home_zoom2);
map3.addControl(home_zoom3);
map4.addControl(home_zoom4);
map5.addControl(home_zoom5);
map6.addControl(home_zoom6);
map7.addControl(home_zoom7);
map8.addControl(home_zoom8);
map9.addControl(home_zoom9);
map10.addControl(home_zoom10);
map11.addControl(home_zoom11);
